// ============================================================
// Tiny helpers and the canonical status map. Lifted from the reference
// (components.jsx) and typed.
// ============================================================
import type { ReservationStatus, CustomerTag } from '../data/types';

/** Pull initials from a name, ignoring common Italian prefixes ("Famiglia X" → "X"). */
export function initials(name: string): string {
  const cleaned = name.replace(/^(Famiglia|Studio|Compleanno|Pranzo)\s+/i, '').trim();
  const parts = cleaned.split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase();
}

/** Deterministic warm-tinted avatar variant for a given name. */
const AV_CLASSES = ['a1', 'a2', 'a3', 'a4'] as const;
export type AvatarVariant = (typeof AV_CLASSES)[number];

export function avatarClass(seed: string): AvatarVariant {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) | 0;
  }
  return AV_CLASSES[Math.abs(h) % AV_CLASSES.length];
}

/** Status → CSS class + i18n key. */
export const STATUS: Record<ReservationStatus, { cls: string; key: string }> = {
  new: { cls: 'new', key: 'st_new' },
  conf: { cls: 'conf', key: 'st_conf' },
  seated: { cls: 'seated', key: 'st_seated' },
  done: { cls: 'done', key: 'st_done' },
  noshow: { cls: 'noshow', key: 'st_noshow' },
  cancel: { cls: 'cancel', key: 'st_cancel' },
};

/** Tag → CSS chip class + i18n key. */
export const TAG: Record<CustomerTag, { cls: string; key: string }> = {
  vip: { cls: 'vip', key: 'tag_vip' },
  regular: { cls: 'regular', key: 'tag_regular' },
  allergy: { cls: 'allergy', key: 'tag_allergy' },
};
